import React from 'react'
import { x } from '@xstyled/styled-components'
import { useParams, Navigate, Link } from 'react-router-dom'
import { Navbar } from '@pool/components/navbar/Navbar'
import { Footer } from '@pool/components/footer/Footer'
import { BlogContent } from '@pool/components/blog/BlogContent'
import { BlogPostSeo } from '@pool/components/blog/BlogSeo'
import { getPostBySlug } from '@pool/content/blog/posts'

export function BlogPostPage() {
  const { slug } = useParams()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [slug])

  const post = getPostBySlug(slug)

  if (!post) {
    return <Navigate to="/blog" replace />
  }

  const { frontmatter, html } = post

  const formattedDate = new Date(frontmatter.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  return (
    <x.main>
      <BlogPostSeo frontmatter={frontmatter} />
      <Navbar />
      <x.article
        maxW="780px"
        mx="auto"
        pt={{ _: '60px', md: '100px' }}
        px={{ _: '24px', md: '24px' }}
        pb={{ _: 16, md: 24 }}>
        {/* Back link */}
        <x.div mb={8}>
          <Link to="/blog" style={{ textDecoration: 'none' }}>
            <x.span
              color={{ _: 'wind', hover: 'lightGreen' }}
              fontSize="14px"
              letterSpacing="0.02em">
              &larr; Back to Blog
            </x.span>
          </Link>
        </x.div>

        {/* Post header */}
        <x.header mb={10}>
          <x.h1
            fontSize={{ _: '32px', md: '44px' }}
            fontWeight="700"
            color="lime"
            lineHeight="1.15"
            letterSpacing="-0.02em"
            mb={5}>
            {frontmatter.title}
          </x.h1>
          <x.div
            display="flex"
            alignItems="center"
            gap={2}
            fontSize="14px"
            color="wind"
            opacity={0.7}>
            <x.span>{frontmatter.author}</x.span>
            <x.span>&middot;</x.span>
            <x.time>{formattedDate}</x.time>
          </x.div>
        </x.header>

        {/* Hero image */}
        {frontmatter.heroImage && (
          <x.div mb={10} borderRadius="8px" overflow="hidden">
            <x.img
              src={frontmatter.heroImage}
              alt={frontmatter.title}
              w="100%"
              display="block"
            />
          </x.div>
        )}

        {/* Content */}
        <BlogContent html={html} />
      </x.article>
      <Footer />
    </x.main>
  )
}
